import React from 'react'
import PropTypes from 'prop-types'

import './FloatingButton.css'

const FloatingButton = ({onClick = () => {}, secondaryOptions = []}) => {
  return <nav className='floating-container'>

    {secondaryOptions.map((option, i) => {
      const tooltip = `title: ${option.toolTip || option.icon}; pos: left`
      // return <span key={i} data-uk-tooltip={tooltip} className={option.icon} />
      return <span
        key={i}
        data-uk-tooltip={tooltip}
        onClick={option.onClick}
        style={{backgroundColor: option.color}}
        className={`uk-align-center floating-button ${option.icon}`} />
    })}
    <i
      onClick={onClick}
      className='fas fa-plus fa-lg floating-button not-clickable shadow' />
  </nav>
}

FloatingButton.propTypes = {
  onClick: PropTypes.func
}

export default FloatingButton
